module.exports = __webpack_public_path__ + "img/icon-user-gender.1e9422bf.svg";